export default __webpack_public_path__ + "static/media/BMW-before.c10b6406.jpg";